import React from 'react';
import { PrivacyPolicySection } from '../components/sections';

export const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="pt-20">
      <PrivacyPolicySection />
    </div>
  );
};
